/**
 * The standard texting alphabet (GSM 03.38): its basic set plus the extension
 * characters. A text made only of these holds 160 characters a segment. One
 * character outside it and the whole text is sent as UCS-2, where a segment
 * holds 70 -- the same wording can then cost two or three times as much.
 *
 * ñ, é and ü are in the set. á, í, ó, ú and Word's curly quotes are not.
 *
 * Only used to warn. Segment and cost estimating is out of scope.
 */
const GSM7 = new Set(
  Array.from(
    "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
      "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà" +
      "^{}\\[~]|€\f",
  ),
)

/** The distinct characters in `text` that fall outside the texting alphabet. */
export function nonGsmCharacters(text: string): string[] {
  const found: string[] = []
  for (const character of Array.from(text)) {
    if (!GSM7.has(character) && !found.includes(character)) found.push(character)
  }
  return found
}
